<template>
  <v-app id="onSmsr">

  <defNavBar title="Ares - SMS message" :actions="smsr.action_items" :home="true" @actionClick="actionClick" />  

    <v-main> 
      
      <v-container fluid>
       
        <v-row>  
          
          <v-col cols="12" lg="6" class="px-1"> <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                  <v-form ref="smsrCard1">
                  <v-card-title>
                    <v-chip :color=smsr.smsr_status_kleur class="mx-4"> {{smsr.smsr_status}} </v-chip>
                    <span class="mx-3 orange--text"> {{smsr.smsr_type}} </span>
                  </v-card-title>

                  <v-row no-gutters>
                    <v-col cols="3" class="mx-1">
                      <v-text-field v-model="smsr.smsr_dt" readonly label="Received Date / Time" dense></v-text-field>
                    </v-col>
                    <v-col cols="3" class="mx-1">
                      <v-text-field v-model="smsr.smsr_tel_vcs" readonly label="Received from" dense></v-text-field>
                    </v-col>
                  </v-row>
                  
                  <v-row no-gutters>
                    <v-col class="mx-2">
                         <v-textarea v-model="smsr.smsr_tekst" :value=smsr.smsr_tekst rows="4" label="Message" counter></v-textarea>
                    </v-col>
                  </v-row>
                  
                  <v-simple-table dense>
                      <template v-slot:default>
                        <tbody>
                          <tr v-for="(sndrRecord,i) in smsr.sndr" :key="i">
                           <td>{{sndrRecord.sndr_type}}</td>
                           <!-- <td @click="$router.open('/eign/onEign/' + sndrRecord.eign_encrid)"><a> {{sndrRecord.eign_code}} </a></td> -->
                           <td>{{sndrRecord.sndr_code }}</td>
                           <td>{{sndrRecord.sndr_naam }}</td>
                           <td>{{sndrRecord.sndr_smsm_dt }}</td>
                           <td> <v-textarea :value=sndrRecord.sndr_smsm_tekst rows="4" label="Message" counter></v-textarea></td>

                           <!-- <td @click="updsndr(sndrRecord.sndr_encrid)"><a>Notifications</a></td> -->
                          
                           <!-- <td><v-btn v-if="sndrRecord.rmsndr === 'Yes'" text icon  @click="rmsndr(sndrRecord.sndr_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></td> -->
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  
                    
                  </v-form>
                  </v-card>
                </v-col>
              </v-row>


            </v-container>
          </v-col>

        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>




<script>
import defNavBar from '@/components/ui/navbars/navbar.vue';
 export default {
  components: {
    defNavBar
  },
  props: ['smsr_encrid'],
  data() {
    return {
      stat_codeKeuzes: [],
      smsr: {
        smsr_naam: '',
        stat_code: '',
        action_items: []  /* moet pre defined ivm length check */
      },
      snackbar: false,
      snackbarMessage: ''
    }
    
  },
  mounted() {
    this.$axios
      .post("ares/json/ares/task/guestMessages/smsr/getSmsr.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getSmsr"
        },
        getSmsr: {
          smsr_encrid: this.smsr_encrid
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.smsr = res.data.getSmsr;
           document.title = 'Booking ' + res.data.getSmsr.smsr_code;
        }
      });

  },
  methods: {
    actionClick(action) {
      switch(action) {
        case "Cancel" : this.$refs.smsrCancel.open(this.smsr_encrid); break;
       
      }
    }
  }
};

</script> 
